import React from 'react';
import IUCNLogo from 'src/assets/images/dashboard/iucn.png';

export type IucnLogoProps = {
    className?: string;
    alt?: string;
};

/**
 * `iucn.png` is 58x54px. Default render size is set to 29x27px so it maps cleanly
 * to 2x device pixel ratio screens (58x54 physical pixels) and stays crisp.
 */
const IucnLogo = ({ className = 'w-[29px] h-[27px]', alt = '' }: IucnLogoProps) => {
    return <img src={IUCNLogo} alt={alt} className={className} width={29} height={27} />;
};

export default IucnLogo;
